import React, { useState, useEffect, useRef } from "react";
import {
  FaBars,
  FaUserCircle,
  FaPlus,
  FaSignOutAlt,
  FaUsers,
} from "react-icons/fa";
import { IoClose, IoMap, IoWallet, IoPerson } from "react-icons/io5";
import { useAuth } from "../../context/AuthContext";
import {
  Nav,
  NavItems,
  MobileNavItems,
  HamburgerButton,
  Overlay,
  Popup,
  Settings,
  StyledNavLink,
  CloseButton,
  NavCenter,
  UserInfo,
  NavIcon,
  MobileNavItem,
  PopupItem,
  LogoContainer,
  PopupLink,
  MobileAccountNavItem,
} from "./style";
import Avatar from "../Avatar";
import Logo from "../Logo";
import ROUTES from "../../routes/routePaths";
import { useNavigate } from "react-router-dom";
import SignupForm from "../SignupForm";

const Navbar = () => {
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { logout, admin } = useAuth();
  const navigate = useNavigate();
  const settingsRef = useRef(null);
  const popupRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };

    // إضافة مستمع للنقر خارج القائمة المنبثقة لإخفائها
    const handleClickOutside = (event) => {
      if (
        popupVisible &&
        settingsRef.current &&
        !settingsRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setPopupVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupVisible, mobileMenuOpen]);

  const handleAddAccountClick = () => {
    setPopupVisible(false);
    setShowAccountForm(true);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    setPopupVisible(false);
    setMobileMenuOpen(false);
    navigate(ROUTES.LOGIN);
  };

  const handlePopupLinkClick = (path) => {
    setPopupVisible(false);
    navigate(path);
  };

  const handleMobileLinkClick = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  const togglePopup = () => {
    if (isMobile) {
      setPopupVisible(!popupVisible);
    }
  };
  console.log(admin?.permissions?.includes("ADMIN_ACCOUNT"));
  return (
    <>
      <Nav>
        <Settings
          ref={settingsRef}
          onMouseEnter={() => !isMobile && setPopupVisible(true)}
          onClick={togglePopup}
        >
          <FaBars className="settings-icon" />
          <UserInfo>
            <Avatar img={admin?.profile_img} name={admin?.name} size="2.5rem" />
          </UserInfo>
          {popupVisible && (
            <Popup
              ref={popupRef}
              onMouseLeave={() => !isMobile && setPopupVisible(false)}
            >
              <PopupLink onClick={() => handlePopupLinkClick(ROUTES.PROFILE)}>
                <PopupItem>
                  <IoPerson />
                  <span>الصفحة الشخصية</span>
                </PopupItem>
              </PopupLink>
              <PopupItem onClick={handleAddAccountClick}>
                <FaPlus />
                <span>إضافة حساب</span>
              </PopupItem>
              {admin?.permissions?.includes("ADMIN_ACCOUNT") && (
                <PopupLink
                  onClick={() => handlePopupLinkClick(ROUTES.ACCOUNTS)}
                >
                  <PopupItem>
                    <FaUsers />
                    <span>الحسابات</span>
                  </PopupItem>
                </PopupLink>
              )}
              <PopupItem onClick={handleLogout} className="logout">
                <FaSignOutAlt />
                <span>تسجيل الخروج</span>
              </PopupItem>
            </Popup>
          )}
        </Settings>
        <NavCenter>
          <NavItems>
            {admin?.permissions?.includes("BALANCES") && (
              <StyledNavLink to={ROUTES.BALANCES}>
                <NavIcon>
                  <IoWallet />
                </NavIcon>
                الأرصدة
              </StyledNavLink>
            )}
            {admin?.permissions?.includes("DRIVER_ACTIONS") && (
              <StyledNavLink to={ROUTES.REQUESTS}>
                <NavIcon>
                  <IoPerson />
                </NavIcon>
                طلبات القبول
              </StyledNavLink>
            )}{" "}
            {admin?.permissions?.includes("BAG_MANAGER") && (
              <MobileNavItem
                onClick={() => handleMobileLinkClick(ROUTES.BAG_MANAGER)}
              >
                <IoPerson />
                <span>امناء الحقائب</span>
              </MobileNavItem>
            )}
            {admin?.permissions?.includes("DRIVERS") && (
              <StyledNavLink to={ROUTES.DRIVERS}>
                <NavIcon>
                  <FaUsers />
                </NavIcon>
                السائقين
              </StyledNavLink>
            )}
            {admin?.permissions?.includes("USERS") && (
              <StyledNavLink to={ROUTES.CUSTOMERS}>
                <NavIcon>
                  <FaUserCircle />
                </NavIcon>
                الزبائن
              </StyledNavLink>
            )}
            {admin?.permissions?.includes("BAG_MANAGER") && (
              <StyledNavLink to={ROUTES.HOME}>
                <NavIcon>
                  <IoMap />
                </NavIcon>
                الخريطة
              </StyledNavLink>
            )}
          </NavItems>
        </NavCenter>

        <LogoContainer>
          <Logo height={4.5} width={5.5} />
        </LogoContainer>

        <HamburgerButton onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <IoClose /> : <FaBars />}
        </HamburgerButton>
      </Nav>

      <MobileNavItems isOpen={mobileMenuOpen}>
        <CloseButton onClick={() => setMobileMenuOpen(false)}>
          <IoClose />
        </CloseButton>

        <UserInfo className="mobile-user">
          <Avatar img={admin?.profile_img} name={admin?.name} size="3.5rem" />
          <h3>{admin?.name || "المسؤول"}</h3>
        </UserInfo>

        <div className="nav-section">
          <h4>القائمة الرئيسية</h4>
          {admin?.permissions?.includes("BALANCES") && (
            <MobileNavItem
              onClick={() => handleMobileLinkClick(ROUTES.BALANCES)}
            >
              <IoWallet />
              <span>الأرصدة</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("DRIVER_ACTIONS") && (
            <MobileNavItem
              onClick={() => handleMobileLinkClick(ROUTES.REQUESTS)}
            >
              <IoPerson />
              <span>طلبات القبول</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("BAG_MANAGER") && (
            <MobileNavItem
              onClick={() => handleMobileLinkClick(ROUTES.BAG_MANAGER)}
            >
              <IoPerson />
              <span>امناء الحقائب</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("DRIVERS") && (
            <MobileNavItem
              onClick={() => handleMobileLinkClick(ROUTES.DRIVERS)}
            >
              <FaUsers />
              <span>السائقين</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("USERS") && (
            <MobileNavItem
              onClick={() => handleMobileLinkClick(ROUTES.CUSTOMERS)}
            >
              <FaUserCircle />
              <span>الزبائن</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("MAP") && (
            <MobileNavItem onClick={() => handleMobileLinkClick(ROUTES.HOME)}>
              <IoMap />
              <span>الخريطة</span>
            </MobileNavItem>
          )}
          {admin?.permissions?.includes("MAP") && (
            <MobileNavItem onClick={() => handleMobileLinkClick(ROUTES.HOME)}>
              <IoMap />
              <span>الخريطة</span>
            </MobileNavItem>
          )}
        </div>

        <div className="nav-section">
          <h4>الحساب</h4>
          <MobileAccountNavItem
            onClick={() => handleMobileLinkClick(ROUTES.PROFILE)}
          >
            <IoPerson />
            <span>الصفحة الشخصية</span>
          </MobileAccountNavItem>
          <MobileAccountNavItem onClick={handleAddAccountClick}>
            <FaPlus />
            <span>إضافة حساب</span>
          </MobileAccountNavItem>
          {admin?.permissions?.includes("ADMIN_ACCOUNT") && (
            <MobileAccountNavItem
              onClick={() => handleMobileLinkClick(ROUTES.ACCOUNTS)}
            >
              <FaUsers />
              <span>الحسابات</span>
            </MobileAccountNavItem>
          )}
          <MobileAccountNavItem onClick={handleLogout} className="logout">
            <FaSignOutAlt />
            <span>تسجيل الخروج</span>
          </MobileAccountNavItem>
        </div>
      </MobileNavItems>

      {showAccountForm && (
        <Overlay onClick={() => setShowAccountForm(false)}>
          <SignupForm
            onClose={() => setShowAccountForm(false)}
            createAdminMutation={(data) => {
              console.log("TODO: أرسل البيانات لـ API", data);
            }}
          />
        </Overlay>
      )}
      {mobileMenuOpen && <Overlay onClick={() => setMobileMenuOpen(false)} />}
    </>
  );
};

export default Navbar;
